module.exports = __webpack_public_path__ + "img/loading.392c4a5.gif";